import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import UserForm from "./components/UserForm";
import HeroSection from "./components/HeroSection";
import TimeTable from "./pages/TimeTable";
import RegisterPage from "./components/RegisterPage";
import LoginPage from "./components/LoginPage";
import FooterLinks from "./components/FooterLinks";
import CombinedSection from "./components/CombinedSection";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions"
import RefundPolicy from "./components/RefundPolicy"
import ShippingPolicy from "./components/ShippingPolicy"
import ContactUs from "./components/ContactUs"


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/users" element={<UserForm />} />
        <Route path="/" element={<HeroSection />} />
        <Route path="/timetable" element={<TimeTable />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/footerLinks" element={<FooterLinks />} />
        <Route path="/combinedSection" element={<CombinedSection />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cancellation-refund" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;
